import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Kilele Exchange',
    shortName: 'Kilele',
    tagline: "Kenya's market, in full resolution.",
    description: 'Live prices for every Nairobi-listed company with indices, a trading terminal, statistics, capital flows, broker sites, trading bots and calculators.',
    disclaimer: 'When the market data feed is connected, latest prices come from the Nairobi Securities Exchange through Mansa API and can be delayed by up to 30 minutes. Older history, order books, investor flows and bond yields are modelled. Trading accounts use virtual money, and nothing here is investment advice.',
    url: getOrigin()
}

export interface NavItem {
    href: string
    label: string
    description: string
}

export const primaryNav: NavItem[] = [
    { href: '/', label: 'Markets', description: 'Session overview, indices, movers and the market map' },
    { href: '/terminal', label: 'Terminal', description: 'Every price, chart, order book and trade on one screen' },
    { href: '/equities', label: 'Equities', description: 'Every listed share with live prices and fundamentals' },
    { href: '/indices', label: 'Indices', description: 'KASI, Kilele 20 and Kilele 25 with constituents' },
    { href: '/bonds', label: 'Bonds', description: 'Treasury bills, the yield curve and listed bonds' },
    { href: '/brokers', label: 'Brokers', description: 'Member firms, their fees and managed portfolios' },
    { href: '/auto-trading', label: 'Auto-trade', description: 'Trading bots and broker-managed portfolios' }
]

export const secondaryNav: NavItem[] = [
    { href: '/statistics', label: 'Statistics', description: 'Risk, return, correlation and market breadth' },
    { href: '/flows', label: 'Flows', description: 'Foreign and local investor flows and order flow' },
    { href: '/calculators', label: 'Calculators', description: 'Trading costs, returns, dividends and valuation' },
    { href: '/announcements', label: 'Announcements', description: 'Market notices and corporate actions' },
    { href: '/mobile', label: 'Mobile app', description: 'Install Kilele on your phone' }
]

export const allNav: NavItem[] = [...primaryNav, ...secondaryNav]

export const TRADING_HOURS = [
    { label: 'Pre-open session', value: '09:00 to 09:30 EAT' },
    { label: 'Continuous trading', value: '09:30 to 15:00 EAT' },
    { label: 'Settlement', value: 'T+3 through the depository' }
]
